import type { HeaderData } from '@/types/aggregation/common';
import type { HeaderViewModel } from '@/types/layout/header-view-model';
import { firstStructuredText, imageUrl, toLinkViewModel } from './layout-field-utils';

type HeaderSource = Partial<HeaderData> | null | undefined;

export const adaptHeader = (source: HeaderSource): HeaderViewModel | null => {
    if (!source) {
        return null;
    }

    const productLogoSrc = imageUrl(source.product_logo);
    const logoAlt = firstStructuredText(source.logo_alt);
    const rgLogo = imageUrl(source.responsible_gaming_logo);
    const rgMessage = firstStructuredText(source.gambling_problem_header_message);

    if (!productLogoSrc || !logoAlt || !rgLogo || !rgMessage) {
        return null;
    }

    const selfExclusionLogo = imageUrl(source.self_exclusion_logo);
    const stateGcbLogo = imageUrl(source.state_gcb_logo);

    return {
        productLogoAlt: logoAlt,
        productLogoSrc,
        sportsbookUrl: toLinkViewModel(source.sportsbook_url).url,
        responsibleGambling: {
            text: rgMessage,
            logo: rgLogo,
            url: toLinkViewModel(source.responsible_gaming_link).url || undefined
        },
        regulatoryLogos: {
            selfExclusionLogo,
            stateGcbLogo
        },
        hasRegulatoryLogos: Boolean(selfExclusionLogo && stateGcbLogo)
    };
};
